import { ThemeConfig } from 'antd'

const THEME: ThemeConfig = {
  token: {
    borderRadius: 8,
  },
}

export default THEME
